

type BasePlanProps = {
  gbPlan: number;
};

const BasePlan: React.FC<BasePlanProps> = ({ gbPlan }) => {
  return (
    <div className='w-full border-t border-gray-100 pb-2 pt-4'>
      <span className='text-xs font-medium uppercase tracking-wider text-gray-400'>Plano Base</span>
      <div className='mt-1.5 flex items-center text-sm text-gray-700'>
        <span>
          <strong className='font-bold'>{gbPlan}GB</strong> de Internet
        </span>
      </div>
    </div>
  );
};

export default BasePlan;
